module.exports = __webpack_public_path__ + "img/parent3.76d513cb.png";